import request from '@/utils/request'
const proxyN = jsvaIPIURL // serviceURL
export function fetchList(query) {
  return request({
    //url: proxyN + 'gdpuser/GetUserList',
    url: proxyN + 'business/multipleServer/multipleTableServer',
    method: 'get',
    params: query
  })
}
export function getUserList(query) {
  query.serviceID = 'GetAppProUserList'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetAppProUserList',
    method: 'post',
    data: query
  })
}
//勘测队用户
export function getSurveyUserList(query) {
  query.serviceID = 'GetSurveyUserList'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetSurveyUserList',
    method: 'post',
    data: query
  })
}
export function getAppUserList(query) {
  query.serviceID = 'getAppUserList'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetAppUserList',
    // url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetUsers',
    method: 'post',
    data: query,
    isredic:true
  })
}
/* 重置密码 */
export function setUsersResetPwds(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=ResetPwds ',
    method: 'get',
    params: query
  })
}

/* 审批 */
export function setAppUserExammines(query) {
  query.serviceID = 'SetUsersEnable'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=SetUsersEnable',
    method: 'post',
    data: query
  })
}

/* 启用停用 */
export function batchUpdateInfo(query) {
  query.serviceID = 'SetUser'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=SetUser',
    method: 'post',
    data: query
  })
}

export function createInfo(data) {
  data.serviceID = 'SetUser'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleAdd?serviceID=SetUser',
    method: 'post',
    data
  })
}

export function updateInfo(data) {
  data.serviceID = 'SetUser'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=SetUser',
    method: 'post',
    data
  })
}

/* 删除多个  */
export function deleteList(query) {
  query.serviceID = 'DelUser'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleDel?serviceID=SetUser',
    method: 'post',
    data: query
  })
}

/* 管理单位  */
export function getLocalityList(query) {
  return request({
    // url: serviceIp + 'System/GetInstcdList',
    url: proxyN + 'gdp/getAllDepts',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetDeptments',
    method: 'get',
    params: query
  })
}
/* 管理单位  */
export function getValleyList(query) {
  return request({
    // url: serviceIp + 'System/GetInstcdList',
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetValleys',
    method: 'get',
    params: query
  })
}
/* web端用户登录 */
export function login(query) {
  return request({
    //url: proxyN + 'gdp/login',
    url: proxyN + 'user/login',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=login',
    method: 'get',
    params: query
  })
}
/** 获取用户(登录)详情 */
export function getInfo(query) {
  query.serviceID = 'getUserListByPage'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    // url: proxyN + 'user/getUserListByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetUsers',
    method: 'post',
    data: query
  })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}

/* 修改密码 */
export function updateUser(data) {
  return request({
    // url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=Testing',
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=SetPwd',
    //url: proxyN + 'business/singleServer/queryTableShowField?serviceID=SetPwd',
    //url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=SetPwd',
    method: 'get',
    params: data
  })
}
